import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/statistics-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/statistics-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/statistics-calculator",
      title: m.st_meta_title(),
      description: m.st_meta_description(),
      toolName: m.st_tool_name(),
      faqs: [
        { q: m.st_faq_q1(), a: m.st_faq_a1() },
        { q: m.st_faq_q2(), a: m.st_faq_a2() },
        { q: m.st_faq_q3(), a: m.st_faq_a3() },
        { q: m.st_faq_q4(), a: m.st_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
